(() => {
  function translateBadges(root = document) {
    const isFrench = (document.documentElement.lang || '').toLowerCase().startsWith('fr');
    if (!isFrench) return;

    root.querySelectorAll('.usf-sale-badge span').forEach(span => {
      const text = span.textContent.trim();
      if (/^save\b/i.test(text)) {
        span.textContent = text.replace(/^save\b/i, 'ÉCONOMISEZ');
      }
    });
  }

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;
        translateBadges(node);
      });
    });
  });

  const init = () => {
    translateBadges();
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init, { once: true })
    : init();
})();